import { render, staticRenderFns } from "./groupRing.vue?vue&type=template&id=a9d6eefe&scoped=true"
import script from "./groupRing.vue?vue&type=script&lang=js"
export * from "./groupRing.vue?vue&type=script&lang=js"
import style0 from "./groupRing.vue?vue&type=style&index=0&id=a9d6eefe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d6eefe",
  null
  
)

export default component.exports